import React, { useEffect, useState } from "react";
import styles from "./StickyFooter.module.css";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";

const CustomiseCta = dynamic(() => import("../CustomiseCta/CustomiseCta"), {
  ssr: false,
  loading: () => (
    <div style={{ width: "100px", height: "40px", background: "#ccc" }} />
  ),
});

interface StickyFooterProps {
  popUpData?: any;
  programOfIntrestLP?: any;
  programOfInterestMultipleOptionList?: boolean;
  data?: {
    desktop_title?: string;
    mobile_title?: string;
    is_sticky_footer_enabled: boolean;
    cta?: {
      type: "redirection-link" | "pop-up" | "youtube-video";
      button: {
        desktop_label?: string;
        mobile_label?: string;
        url?: string;
        text_color: string;
        button_color: string;
      };
      icon_and_position?: {
        icon?: {
          url: string;
          alternativeText?: string;
        };
        horizontal_position?: "left" | "right";
      };
    };
  };
}

const StickyFooter: React.FC<StickyFooterProps> = ({
  data,
  popUpData,
  programOfIntrestLP,
  programOfInterestMultipleOptionList,
}) => {
  const router = useRouter();
  const [isMobile, setIsMobile] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const isLPPage = router.pathname.includes("/lp");

  useEffect(() => {
    setIsMobile(window.innerWidth <= 700);

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 700);
    };

    window.addEventListener("resize", handleResize, { passive: true });
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  if (!data || !data.is_sticky_footer_enabled) return null;

  return (
    <div
      className={`${styles.stickyFooter} ${isVisible ? styles.visible : ""}`}
      aria-live="polite"
    >
      <div className="container">
        <div
          className={`${
            isLPPage
              ? styles.stickyFooterContainerLPStyle
              : styles.stickyFooterContainer
          }`}
        >
          <span className={styles.text}>
            {isMobile ? data?.mobile_title : data?.desktop_title}
          </span>
          {data?.cta && (
            <div className={styles.buttonContainer}>
              <CustomiseCta
                ctaData={data?.cta}
                mixpanelEvent="enrol_now_clicked"
                popupData={popUpData}
                programOfIntrestLP={programOfIntrestLP}
                programOfInterestMultipleOptionList={
                  programOfInterestMultipleOptionList
                }
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(StickyFooter);
